import { MutationHookOptions, useMutation } from '@apollo/client';

import { REMOVE_CHILD } from './mutations';

export const useDeleteChild = (options?: MutationHookOptions) => useMutation(REMOVE_CHILD, options);
